<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.accepted_ad_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #404b3e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Ad Information Section -->
          <div class="col-12 mb-4">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.ad_information") }}
            </h5>
          </div>

          <!-- Start:: Ad ID -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.AcceptedAds.ad_number')"
            v-model.trim="data.id"
            disabled
          />
          <!-- End:: Ad ID -->

          <!-- Start:: Ad Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.AcceptedAds.ad_name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Ad Name -->

          <!-- Start:: Shop Type -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_type')"
            v-model.trim="data._shop_type"
            disabled
          />
          <!-- End:: Shop Type -->

          <!-- Start:: Area -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.area_wide')"
            v-model.trim="data.area"
            disabled
          />
          <!-- End:: Area -->

          <!-- Start:: Shop Status -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.shop_status')"
            v-model.trim="data._shop_status"
            disabled
          />
          <!-- End:: Shop Status -->

          <!-- Start:: Payment Due -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.payment_due')"
            v-model.trim="data._payment_due"
            disabled
          />
          <!-- End:: Payment Due -->

          <!-- Start:: Rent Price -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.rent_price')"
            v-model.trim="data.rent_price"
            disabled
          />
          <!-- End:: Rent Price -->

          <!-- Start:: Allowed Activities -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.allowed_activities')"
            :value="
              data.allowed_activities
                ? data.allowed_activities.map((a) => a.name).join(', ')
                : ''
            "
            disabled
          />
          <!-- End:: Allowed Activities -->

          <!-- Start:: Blocked Activities -->
          <base-input
            v-if="data.blocked_activities && data.blocked_activities.length"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.blocked_activities')"
            :value="data.blocked_activities.map((a) => a.name).join(', ')"
            disabled
          />
          <!-- End:: Blocked Activities -->

          <!-- Start:: Status -->
          <!-- <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            :value="
              data.is_active
                ? $t('TABLES.AcceptedAds.active')
                : $t('TABLES.AcceptedAds.inactive')
            "
            disabled
          /> -->
          <!-- End:: Status -->

          <!-- Start:: Created At -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('TABLES.AcceptedAds.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created At -->

          <!-- Start:: Location Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.location_information") }}
            </h5>
          </div>

          <!-- Start:: Region -->
          <base-input
            v-if="data.region"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.region')"
            v-model.trim="data.region.name"
            disabled
          />
          <!-- End:: Region -->

          <!-- Start:: City -->
          <base-input
            v-if="data.city"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city.name"
            disabled
          />
          <!-- End:: City -->

          <!-- Start:: District -->
          <base-input
            v-if="data.district"
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.district')"
            v-model.trim="data.district.name"
            disabled
          />
          <!-- End:: District -->

          <!-- Start:: Map -->
          <div class="col-12 mb-4" v-if="data.lat && data.lng">
            <h6 style="color: #404b3e; margin-bottom: 15px">
              {{ $t("PLACEHOLDERS.location_on_map") }}
            </h6>
            <div style="height: 300px">
              <MapComponent
                :latitude="parseFloat(data.lat)"
                :longitude="parseFloat(data.lng)"
              />
            </div>
          </div>
          <!-- End:: Map -->

          <!-- Start:: Advertiser Information Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.advertiser_information") }}
            </h5>
          </div>

          <!-- Start:: Advertiser Name -->
          <base-input
            v-if="data.user && data.user.user"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advertiser_name')"
            v-model.trim="data.user.user.name"
            disabled
          />
          <!-- End:: Advertiser Name -->

          <!-- Start:: Advertiser Mobile -->
          <base-input
            v-if="data.user && data.user.user"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.mobile')"
            v-model.trim="data.user.user.mobile"
            disabled
          />
          <!-- End:: Advertiser Mobile -->

          <!-- Start:: Advertiser Email -->
          <base-input
            v-if="data.user && data.user.user && data.user.user.email"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.user.user.email"
            disabled
          />
          <!-- End:: Advertiser Email -->

          <!-- Start:: Advertiser Type -->
          <base-input
            v-if="data.user && data.user.user"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.advertiser_type')"
            v-model.trim="data.user.user._landlord_type"
            disabled
          />
          <!-- End:: Advertiser Type -->

          <!-- Start:: Images Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #404b3e;
                border-bottom: 2px solid #404b3e;
                padding-bottom: 10px;
              "
            >
              {{ $t("TITLES.ad_images") }}
            </h5>
          </div>

          <!-- Start:: Ad Images -->
          <div class="col-12 mb-4" v-if="data.images && data.images.length">
            <div class="row">
              <div
                class="col-4 mb-3"
                v-for="image in data.images"
                :key="image.id"
              >
                <img
                  :src="image.image"
                  :alt="data.name"
                  style="
                    width: 100%;
                    height: 200px;
                    object-fit: cover;
                    border-radius: 8px;
                    cursor: pointer;
                  "
                  @click="openImageModal(image.image)"
                />
              </div>
            </div>
          </div>
          <div class="col-12 mb-4" v-else>
            <p class="text-muted text-center">
              {{ $t("MESSAGES.no_images_available") }}
            </p>
          </div>
          <!-- End:: Ad Images -->
        </div>
      </form>
    </div>

    <!-- Start:: Image Modal -->
    <v-dialog v-model="imageModalIsOpen" max-width="800">
      <v-card>
        <v-card-text class="text-center">
          <img :src="selectedImage" style="max-width: 100%; max-height: 80vh" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="modal_cancel_btn" @click="imageModalIsOpen = false">
            {{ $t("BUTTONS.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MapComponent from "@/components/general/MapComponent.vue";

export default {
  name: "ShowAcceptedAd",

  components: {
    MapComponent,
  },

  data() {
    return {
      // Start:: Data
      data: {},
      // End:: Data

      // Start:: Image Modal Data
      imageModalIsOpen: false,
      selectedImage: null,
      // End:: Image Modal Data
    };
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      updateAppLoadingStatus: "LoadingModule/updateAppLoadingStatus",
    }),
    // End:: Vuex Actions

    // Start:: Get Data
    async getData() {
      this.updateAppLoadingStatus(true);

      try {
        let res = await this.$axios({
          method: "GET",
          url: `ads/${this.$route.params.id}`,
        });
        this.updateAppLoadingStatus(false);
        this.data = res.data.data.ad;
      } catch (error) {
        this.updateAppLoadingStatus(false);
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.failed")
        );
      }
    },
    // End:: Get Data

    // Start:: Open Image Modal
    openImageModal(imageSrc) {
      this.selectedImage = imageSrc;
      this.imageModalIsOpen = true;
    },
    // End:: Open Image Modal
  },

  created() {
    this.getData();
  },
};
</script>
